export enum IncidentStatusEnum {
  New = "new",
  Closed = "closed",
}

export type TIncidentStatus =
  (typeof IncidentStatusEnum)[keyof typeof IncidentStatusEnum];
